// Removing a Draft asks staff to type its title to confirm. An untitled Draft
// has nothing to type, so it gets a plain confirmation instead — otherwise it
// could never be removed.

export const draftRemovalNeedsTypedTitle = (title: string | undefined) =>
  Boolean(title?.trim());

export const canConfirmDraftRemoval = (
  title: string | undefined,
  typedTitle: string,
) =>
  !draftRemovalNeedsTypedTitle(title) ||
  typedTitle.trim() === title?.trim();
